import Button from "@elements/button";
import { useAppContext } from "@context/app";
import WarningIcon from "@svg/WarningIcon";

interface AddressProps {
  setClose: (data: boolean) => void;
}

const ConfirmChangeAddress: React.FC<AddressProps> = ({ setClose }) => {
  const {
    cart,
    setUserOldCart,
    setUserDeliveryAddress,
    deliveryAddress,
    oldDeliveryAddress,
    setUserOldDeliveryAddress,
  } = useAppContext();

  const undoAddress = () => {
    if (oldDeliveryAddress && deliveryAddress) {
      const oldAddress = { ...oldDeliveryAddress };
      setUserDeliveryAddress(oldAddress);
      setUserOldDeliveryAddress(undefined);
    }
    setClose(false);
  };

  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] min-h-[410px] h-[max-content] bg-white rounded-lg p-4 flex flex-col justify-between">
      <div className=" w-full flex flex-wrap mb-5 items-center">
        <p className="flex-1 font-normal text-xl text-[#333] text-center">
          Product Availability
        </p>
      </div>
      <div className=" flex flex-col items-center w-full">
        <WarningIcon />
        <p className=" text-[#999] font-normal text-sm text-center max-w-[340px] mt-4 leading-6">
          Some products in cart might be unavailable at this address. Update
          cart to review them or continue with your previous address.
        </p>
      </div>
      <div className="w-full mt-2">
        <div className="w-full flex flex-wrap justify-center">
          <Button
            size="slim"
            className="flex-1 max-w-52 h-12 font-extrabold text-base rounded-full m-2"
            theme="lightBlue"
            onClick={() => undoAddress()}
          >
            Dismiss{" "}
          </Button>
          <Button
            size="slim"
            className="flex-1 max-w-52 h-12 font-extrabold text-base rounded-full m-2"
            onClick={() => {
              setUserOldCart(cart);
              setClose(false);
            }}
          >
            Change Address{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmChangeAddress;
